import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Line } from 'react-chartjs-2';
import { getSaleStats } from '../../actions/saleStats';
import {
  DATE_LABELS,
  buildChartData,
  formatTooltip,
  formatTick,
  ChartData,
  Sale,
} from './salesGraphUtils';

interface Props {
  salesGraph: { sales: Sale[]; loading: boolean };
  getSaleStats: (months: number) => void;
}

const SalesGraph: React.FC<Props> = ({ salesGraph, getSaleStats }: any) => {
  const [data, setData] = useState<ChartData | {}>({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [fetchDate, setFetchDate] = useState(12);

  useEffect(() => {
    getSaleStats(fetchDate);
  }, [fetchDate, getSaleStats]);

  useEffect(() => {
    if (salesGraph.sales?.length) {
      setData(buildChartData(salesGraph.sales));
    }
  }, [salesGraph.sales]);

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Sales</p>
        <div className="admin-dropdown-wrap">
          <button className="admin-dropdown-trigger" onClick={() => setDropdownOpen((o) => !o)}>
            {DATE_LABELS[fetchDate]}
            <i className="fas fa-chevron-down ml-2" style={{ fontSize: '0.7rem' }} />
          </button>
          {dropdownOpen && (
            <div className="admin-dropdown-menu">
              {Object.entries(DATE_LABELS).map(([months, label]) => (
                <button
                  key={months}
                  className={`admin-dropdown-item${Number(months) === fetchDate ? ' active' : ''}`}
                  onClick={() => {
                    setFetchDate(Number(months));
                    setDropdownOpen(false);
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="admin-card-body">
        <Line
          data={data}
          options={{
            maintainAspectRatio: true,
            scales: {
              yAxes: [{ ticks: { beginAtZero: true, callback: formatTick } }],
            },
            tooltips: {
              callbacks: { label: formatTooltip },
            },
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  salesGraph: state.salesGraphReducer,
});

export default connect(mapStateToProps, { getSaleStats })(SalesGraph);
